__turbopack_context__.v({
  "quoteBarContainer": "M5uW4a_quoteBarContainer",
  "quoteListFaded": "M5uW4a_quoteListFaded",
  "quoteListReady": "M5uW4a_quoteListReady",
});
